import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import hu from '@/i18n/hu.json'

/**
 * react-i18next setup (DEC-FE-008 / DEC-FE-013).
 * Default locale `hu`; admin app csak hu-ban (en post-MVP, ha kell).
 */
void i18n.use(initReactI18next).init({
  resources: {
    hu: { translation: hu },
  },
  lng: 'hu',
  fallbackLng: 'hu',
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
})

export default i18n
